import { render } from "./AdminBoxPMS.vue?vue&type=template&id=28c7677e&scoped=true"
import script from "./AdminBoxPMS.vue?vue&type=script&lang=js"
export * from "./AdminBoxPMS.vue?vue&type=script&lang=js"

import "./AdminBoxPMS.vue?vue&type=style&index=0&id=28c7677e&scoped=true&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c7677e"]])

export default __exports__